import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import '../styles/HptScreens.css';
import SignaturePad from './SignaturePad';
import imagenFondo from '../assets/logo_elecnor.jpg';
import html2pdf from 'html2pdf.js';


const API_URL = process.env.REACT_APP_API_URL;

const PermisoQuimicos = ({ datosPrevios, onSave, onCancel, readOnly = false, usuarioActual, isPdfMode = false }) => {

    const { id } = useParams();
    const navigate = useNavigate();
    const isStandalone = typeof onSave !== 'function' && !isPdfMode;
    const pdfRef = useRef();
    const [isPrintingLocal, setIsPrintingLocal] = useState(false);

    
    const itemsChecklist = [
        { key: "q1", label: "1- ¿Se ha identificado el producto químico revisando la etiqueta del mismo?" },
        { key: "q2", label: "2- ¿Se ha localizado y revisado la ficha de seguridad del producto?" },
        { key: "q3", label: "3- ¿Se ha verificado si el producto requiere dilución o no?" },
        { key: "q4", label: "4- ¿Se dispone de los EPI's básicos de planta?" },
        { key: "q5", label: "5- ¿Se dispone de mono químico de clase III en condiciones óptimas?" },
        { key: "q6", label: "6- ¿Se dispone de guantes químicos necesarios de clase III en condiciones óptimas?" },
        { key: "q7", label: "7- ¿Se dispone de botas contras salpicadura de clase S5?" },
        { key: "q8", label: "8- ¿Se dispone de máscara integral con filtros ABEK1HGP3?" },
        { key: "q9", label: "9- ¿Se dispone de pantalla facial? Necesario en caso de que las máscara de filtros no sea integral." },
        { key: "q10", label: "10- ¿El personal implicado en la manipulación/trasvase de productos químicos tiene la cualificación necesaria para ello?" },
        { key: "q11", label: "11- ¿El operario tiene la cualificación necesaria para utilizar la carretilla elevadora?" },
        { key: "q12", label: "12- ¿Se localizado una ducha lava-ojos a una distancia inferior a 10 metros y verificado su funcionamiento?" },
        { key: "q13", label: "13- ¿Se dispone de material adsorbente (sepiolita en caso de que no se especifique otro tipo)?" },
        { key: "q14", label: "14- ¿Se dispone de las herramientas y equipos necesarios para el trabajo?" },
        { key: "q15", label: "15- ¿Se ha localizado la manguera específica para realizar el trasvase?" },
        { key: "q16", label: "16- ¿Se dispone de zona protegida ante derrame o vertido en condiciones óptimas?" },
        { key: "q17", label: "17- ¿Se encuentra el envase colocado de forma correcta, con apoyo estable?" },
        { key: "q18", label: "18- ¿Se ha señalizado y balizado la zona de carga respetando una distancia mínima de 5 metros sobre los elementos de contención y bombeo?" },
        { key: "q19", label: "19- ¿Se encuentra la carretilla elevadora fuera de la zona balizada?" },
        { key: "q20", label: "20- ¿Se han conectado los elementos para realizar la carga y se ha verificado que no hay presencia de fugas o deficiencias?" },
        { key: "q21", label: "21- ¿Se encuentran las mangueras y tuberías vacias y limpias?" },
        { key: "q22", label: "22- ¿Se ha limpiado y recogido todo el material utilizado?" },
        { key: "q23", label: "23- ¿Se ha retirado y segregado correctamente el material adsorbente utilizado?" },
        { key: "q24", label: "24- ¿Se ha segregado correctamente cualquier residuo excedente de producto que haya podido generarse durante el trasvase?" }
    ];

    const rastroEstadoInicial = {
        fechaInspeccion: new Date().toISOString().split('T')[0],
        horaInspeccion: new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }),
        operadoresEjecutantes: '', 
        actividadRealizar: '',
        firmaJefeTurno: null, firmaJefeTrabajo: null, firmaRecursoPreventivo: null
    };

    itemsChecklist.forEach(item => { rastroEstadoInicial[item.key] = ''; });

    const [formData, setFormData] = useState(datosPrevios || rastroEstadoInicial);
    const [firmaActiva, setFirmaActiva] = useState(null);

    useEffect(() => {
        if (isStandalone && id) {
            const cargarDatos = async () => {
                try {
                    const token = localStorage.getItem('userToken');
                    const res = await axios.get(`${API_URL}/api/hpt/quimicos/${id}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    
                    const dbData = res.data;
                    setFormData({
                        fechaInspeccion: dbData.fecha_inspeccion || "",
                        horaInspeccion: dbData.hora_inspeccion || "",
                        operadoresEjecutantes: dbData.operadores_ejecutantes || "",
                        actividadRealizar: dbData.actividad_realizar || "",
                        q1: dbData.check_q1 || "", q2: dbData.check_q2 || "", q3: dbData.check_q3 || "",
                        q4: dbData.check_q4 || "", q5: dbData.check_q5 || "", q6: dbData.check_q6 || "",
                        q7: dbData.check_q7 || "", q8: dbData.check_q8 || "", q9: dbData.check_q9 || "",
                        q10: dbData.check_q10 || "", q11: dbData.check_q11 || "", q12: dbData.check_q12 || "",
                        q13: dbData.check_q13 || "", q14: dbData.check_q14 || "", q15: dbData.check_q15 || "",
                        q16: dbData.check_q16 || "", q17: dbData.check_q17 || "", q18: dbData.check_q18 || "",
                        q19: dbData.check_q19 || "", q20: dbData.check_q20 || "", q21: dbData.check_q21 || "",
                        q22: dbData.check_q22 || "", q23: dbData.check_q23 || "", q24: dbData.check_q24 || "",
                        firmaJefeTurno: dbData.firma_jefe_turno ? JSON.parse(dbData.firma_jefe_turno) : null,
                        firmaJefeTrabajo: dbData.firma_jefe_trabajo ? JSON.parse(dbData.firma_jefe_trabajo) : null,
                        firmaRecursoPreventivo: dbData.firma_recurso_preventivo ? JSON.parse(dbData.firma_recurso_preventivo) : null
                    });
                } catch (error) {
                    Swal.fire('Error', 'No se pudo cargar el documento', 'error');
                }
            };
            cargarDatos();
        }
    }, [id, isStandalone]);

    const handleGuardarDirecto = async () => {
        try {
            const token = localStorage.getItem('userToken');
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const payload = { ...formData, id_hpt: null };

            if (id) {
                await axios.put(`${API_URL}/api/hpt/quimicos/${id}`, payload, config);
                Swal.fire({
                    title: "¡Actualizado!", text: `Registro actualizado correctamente`, icon: "success",
                    confirmButtonColor: '#003366', timer: 2500
                });
            }else{
                const res = await axios.post(`${API_URL}/api/hpt/quimicos`, payload, config);

                Swal.fire({
                    title: "¡Guardado!", text: `Registrado con ID: ${res.data.id_registro}`, icon: "success",
                    confirmButtonColor: '#003366', timer: 2500
                });
            }
        } catch (error) {
            Swal.fire('Error', 'No se pudo guardar en el servidor.', 'error');
        }
    };

    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleGuardarFirma = (base64) => {
        const fechaHora = new Date().toLocaleString('es-ES');
        let nombreCompleto = usuarioActual;
        if (!nombreCompleto) {
            const token = localStorage.getItem('userToken');
            if (token) {
                const dec = JSON.parse(atob(token.split('.')[1]));
                nombreCompleto = `${dec.nombre || ''} ${dec.apellidos || ''}`.trim() || dec.user;
            } else {
                nombreCompleto = 'Usuario Desconocido';
            }
        }

        setFormData({
            ...formData,
            [firmaActiva]: { base64: base64, nombre: nombreCompleto, fechaHora: fechaHora }
        });
        setFirmaActiva(null);
    };

    const tieneRespuestasNegativas = itemsChecklist.some(item => formData[item.key] === 'NO');

    const renderCajaFirma = (label, fieldKey) => {
        const firma = formData[fieldKey];
        return (
            <div className="spe-sign-line">
                <span style={{ fontWeight: 'bold', fontSize: '12px', marginBottom: '5px', color: '#003366' }}>{label}:</span>
                {firma ? (
                    <div style={{ backgroundColor: '#fff', padding: '5px', borderRadius: '4px', border: '1px solid #ddd', width: '100%', boxSizing: 'border-box' }}>
                        <img src={firma.base64} alt="Firma" style={{ height: '35px', display: 'block', marginBottom: '5px' }} />
                        <div style={{ fontSize: '9px', color: '#555', lineHeight: '1.2' }}>
                            <strong>Por:</strong> {firma.nombre} <br/>
                            <strong>Fecha:</strong> {firma.fechaHora}
                        </div>
                    </div>
                ) : (
                    !readOnly && (
                        <button type="button" className="btn-save" style={{ width: 'fit-content', padding: '4px 10px', fontSize: '11px', backgroundColor: '#003366', marginTop: 'auto' }} onClick={() => setFirmaActiva(fieldKey)}>
                            ✍️ Firmar
                        </button>
                    )
                )}
            </div>
        );
    };

    const handleDescargarPDF = () => {
        setIsPrintingLocal(true);
        Swal.fire({ title: 'Generando documento...', text: 'Por favor espera', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
        setTimeout(() => {
            const element = pdfRef.current;
            const opt = {
                margin:       [10, 5, 10, 5],
                filename:     `Permiso_${new Date().getTime()}.pdf`,
                image:        { type: 'jpeg', quality: 0.98 },
                html2canvas:  { scale: 2, useCORS: true, windowWidth: 720 },
                jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true },
                pagebreak:    { mode: ['css', 'legacy'] }
            };
            html2pdf().set(opt).from(element).save().then(() => {
                setIsPrintingLocal(false);
                Swal.close();
            });
        }, 800);
    };

    const contenidoFormulario = (
        <div className={`pe-container ${isPdfMode || isPrintingLocal ? 'pe-pdf-mode' : 'pe-modal-content'}`}>
            <div ref={pdfRef}
                className={`pe-container ${isPdfMode || isPrintingLocal ? 'pe-pdf-mode' : 'pe-modal-content'}`}
                style={isPrintingLocal ? { width: '720px', maxWidth: '720px', margin: '0 auto', backgroundColor: '#fff', transform: 'none' } : {}}

            > 
                <header className="spe-header">
                    <div className="spe-logo"><img src={imagenFondo} alt="Logo" style={{ maxHeight: '40px' }} /></div>
                    <div className="spe-title-box"><h2 className="spe-main-title" style={{ fontSize: '14px' }}>COMPROBACIONES DE MANIPULACIÓN DE QUÍMICOS</h2></div>
                    <div className="spe-code" style={{ fontSize: '10px' }}>FI.TER.AST.QUI-22.06A</div>
                </header>

                <section className="spe-section">
                    <div className="spe-dat_sol-2">
                        <div className="spe-input-group"><span className="info-label">FECHA:</span><input type="date" name="fechaInspeccion" value={formData.fechaInspeccion} onChange={handleChange} disabled={readOnly} className="spe-input" /></div>
                        <div className="spe-input-group"><span className="info-label">HORA:</span><input type="text" name="horaInspeccion" value={formData.horaInspeccion} onChange={handleChange} disabled={readOnly} className="spe-input" /></div>
                        <div className="spe-input-group"><span className="info-label">OPERADORES EJECUTANTES:</span><input type="text" name="operadoresEjecutantes" value={formData.operadoresEjecutantes} onChange={handleChange} disabled={readOnly} className="spe-input" /></div>
                    </div>
                    <div className="spe-input-group" style={{ marginTop: '8px' }}><span className="info-label">ACTIVIDAD A REALIZAR:</span><input type="text" name="actividadRealizar" value={formData.actividadRealizar} onChange={handleChange} disabled={readOnly} className="spe-input" style={{ width: '100%' }} /></div>
                </section>

                <section className="spe-section">
                    <h3 className="spe-section-title">Comprobaciones previas al inicio del trabajo (Ejecutante)</h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', backgroundColor: '#eee', padding: '1px' }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 15mm 15mm 15mm', backgroundColor: '#003366', color: '#fff', padding: '6px 10px', fontSize: '11px', fontWeight: 'bold', textAlign: 'center', alignItems: 'center' }}>
                            <div style={{ textAlign: 'left' }}>Puntos de Comprobación Requeridos</div><div>SI</div><div>NO</div><div>NP</div>
                        </div>

                        {itemsChecklist.map((item, index) => {
                            let subheader = null;
                            if (index === 0) subheader = "a) Trabajos previos";
                            if (index === 16) subheader = "b) Trabajos de trasvase";
                            if (index === 20) subheader = "c) Finalización de los trabajos";

                            return (
                                <React.Fragment key={item.key}>
                                    {subheader && (
                                        <div style={{ backgroundColor: '#d9d9d9', padding: '4px 10px', fontWeight: 'bold', fontSize: '11px', color: '#003366' }}>{subheader}</div>
                                    )}
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 15mm 15mm 15mm', backgroundColor: index % 2 === 0 ? '#fff' : '#f5f7fa', padding: '4px 10px', fontSize: '10.5px', alignItems: 'center', minHeight: '28px' }}>
                                        <div style={{ paddingRight: '10px', color: '#333' }}>{item.label}</div>
                                        <div style={{ textAlign: 'center' }}><input type="radio" name={item.key} value="SI" checked={formData[item.key] === 'SI'} onChange={handleChange} disabled={readOnly} /></div>
                                        <div style={{ textAlign: 'center' }}><input type="radio" name={item.key} value="NO" checked={formData[item.key] === 'NO'} onChange={handleChange} disabled={readOnly} /></div>
                                        <div style={{ textAlign: 'center' }}><input type="radio" name={item.key} value="NP" checked={formData[item.key] === 'NP'} onChange={handleChange} disabled={readOnly} /></div>
                                    </div>
                                </React.Fragment>
                            );
                        })}
                    </div>
                </section>

                <div className={`spe-alert ${tieneRespuestasNegativas ? 'spe-alert-danger' : ''}`} style={{ transition: 'all 0.3s ease' }}>
                    ¡¡¡¡¡¡¡¡ATENCIÓN, si has contestado que NO a algunas de estas preguntas, NO PUEDES REALIZAR EL TRABAJO hasta solucionar éste punto!!!!!!!!!!!
                </div>

                <section className="spe-section">
                    <div className="spe-signature-box" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
                        {renderCajaFirma('Jefe de Turno, firma e iniciales', 'firmaJefeTurno')}
                        {renderCajaFirma('Jefe de Trabajo, firma e iniciales', 'firmaJefeTrabajo')}
                        {renderCajaFirma('Recurso Preventivo, firma e iniciales', 'firmaRecursoPreventivo')}
                    </div>
                </section>

            </div>

            {!isPdfMode && (
                <div className="spe-modal-actions">
                    <button type="button" className="btn-close" onClick={() => isStandalone ? navigate('/dashboard') : onCancel()}>
                        {readOnly ? '❌ Cerrar' : '❌ Cancelar'}
                    </button>
                    <button type="button" className="btn-print" onClick={handleDescargarPDF} style={{ backgroundColor: '#0288d1', color: '#fff', padding: '6px 15px', fontWeight: 'bold' }}>
                        🖨️ Imprimir Hoja
                    </button>
                    {!readOnly && (
                        <button type="button" className="btn-save" style={{ backgroundColor: '#2e7d32' }} onClick={() => isStandalone ? handleGuardarDirecto() : onSave(formData)}>
                            💾 Guardar Anexo
                        </button>
                    )}
                </div>
            )}

            {firmaActiva && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 100000 }}>
                    <SignaturePad onSave={handleGuardarFirma} onCancel={() => setFirmaActiva(null)} />
                </div>
            )}
        </div>
    );

    if (isPdfMode) return contenidoFormulario;

    return (
        <div className={isStandalone ? "container" : "spe-modal-overlay"}>
            {contenidoFormulario}
        </div>
    );
};

export default PermisoQuimicos;